import React from "react";
import Routes from "./Router/routers";
import { unstable_HistoryRouter as HistoryRouter } from "react-router-dom";
import { createHashHistory } from "history";
import { Layout } from "antd";
import "antd/dist/antd.css";
import "./App.scss";

const App = () => {
  return (
    <HistoryRouter history={history}>
      <Layout className="layout">
        <Routes />
      </Layout>
    </HistoryRouter>
  );
};

export const history = createHashHistory();
//export const history = createHashHistory({ basename: process.env.PUBLIC_URL });
export default App;
